var ownClasses = {"item-icon":"RecentSearches-module_item-icon__ux5yT","title":"RecentSearches-module_title__tigyA"};

export { ownClasses as default };
//# sourceMappingURL=RecentSearches.module.scss.js.map
